// extracted by mini-css-extract-plugin
export default {"root":"WelcomeStep__root--2L8IK","title":"WelcomeStep__title--2JYEg","size":"WelcomeStep__size--3_ffe","text":"WelcomeStep__text--3qZXy"};